
<template>
  <div>
    <span class="title">学习班:</span>
    <el-select 
        v-model="value" 
        placeholder="请选择学习班" 
        filterable 
        clearable 
        remote 
        :remote-method="remoteMethod" 
        @change="onValSelect"
        :loading="loading" 
        class="sel">
      <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id" class="optw"></el-option>
    </el-select>
  </div>
</template>

<script>
import { options as optionsApi } from "@/api/module/studyclass/studyclass";

export default {
  name : 'SchedulingSelect',
  data(){
    return {
      datas : [],
      value : "",
      selectItem: {},
      loading : false,
      options : []
    }
  },
  methods:{
    init(){
      this.fetchData('')
    },
    remoteMethod(query){
      if(query){
        this.fetchData(query);
      }
    },

    fetchData(query){
      let data = {
        "title" : query
      }
      optionsApi(data)
        .then((r)=>{
          this.options = r;               
        })
    },

    onValSelect(val){
      for(let i = 0; i < this.options.length;i++){
        if(this.options[i].id == val){
          this.selectItem = this.options[i];
        }
      }
      this.$emit("onValueChanged",val,this.selectItem);
    }
  },
  mounted(){
    this.init();
  }
}
</script>





<style scoped>
.title {
  font-size: 13px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}

.sel{
  width: 300px;
}

.optw{
  width: 600px;
}
</style>